import React, { Component, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../../store/OrderPlannerContact';
import './OrderPlannerContact.css';
import { ListGroup, ListGroupItem, Button } from 'react-bootstrap';
import ResetOrderPlannerDataButton from '../common/ResetOrderPlannerData';
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css';
import { creditCardAlt } from 'react-icons-kit/fa/creditCardAlt';
import { ccAmex } from 'react-icons-kit/fa/ccAmex';
import { ccDiscover } from 'react-icons-kit/fa/ccDiscover';
import { ccMastercard } from 'react-icons-kit/fa/ccMastercard';
import { ccVisa } from 'react-icons-kit/fa/ccVisa';

import 'font-awesome/css/font-awesome.min.css';
import Icon from 'react-icons-kit';

class OrderPlannerContact extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedContact: localStorage.getItem('orderPlannerContact') || ''
        };

        this.handleContactSelection = this.handleContactSelection.bind(this);
    }

    componentWillMount() {
        // This method runs when the component is first added to the page
        if (!localStorage.getItem('customer')) {
            window.open('/customer-search', '_self');
        }

        this.props.history.push('/order-planner-contact/');

        console.log(localStorage);

        this.props.queryOrderPlannerContacts();
    }

    componentWillReceiveProps(nextProps) {
        // This method runs when incoming props (e.g., route params) change
    }

    handleContactSelection(contactId, contactName, contactEmail, contactPhone, contactLastFourCCDigits) {
        if (contactId !== 'NA') {
            if (this.props.requireCC && contactLastFourCCDigits === '') {
                localStorage.removeItem('orderPlannerContact');
                localStorage.removeItem('orderPlannerContactName');
                localStorage.removeItem('orderPlannerContactEmail');
                localStorage.removeItem('orderPlannerContactPhone');

                return;
            }

            localStorage.setItem('orderPlannerContact', contactId);
            localStorage.setItem('orderPlannerContactName', contactName);
            if (contactEmail) {
                localStorage.setItem('orderPlannerContactEmail', contactEmail);
            }
            if (contactPhone) {
                localStorage.setItem('orderPlannerContactPhone', contactPhone)
            }
        }
    }

    render() {
        return (
            <div>
                <h1>1. Contact</h1>
                <div id="current-cust">
                    <b>
                        [{localStorage.getItem('customer')}] {localStorage.getItem('customerName')}
                        <i className={'fa fa-user'}
                            style={{
                                cursor: 'pointer',
                                color: "black",
                                marginLeft: "5px"
                            }}
                            onClick={() => window.open('/customer-search', '_self')}
                        />
                        <br />
                        {localStorage.getItem('addressName')}<br />
                        {localStorage.getItem('city')}, {localStorage.getItem('state')} {localStorage.getItem('zip')}
                    </b>
                </div>
                <br />
                <span style={{ fontWeight: '700' }}>
                    <Icon icon={creditCardAlt} size={24} style={this.props.requireCC ? {} : { display: 'none' }} />
                    {this.props.requireCC ? ' A credit card is required for this order.' : ''}
                </span>
                <br />
                <ListGroup>
                    {this.props.contacts.map(contact =>
                        <ListGroupItem key={contact.Id} header={contact.Name}
                            active={this.state.selectedContact === contact.Id ? true : false}
                            onClick={() => {
                                this.setState({ selectedContact: contact.Id });
                                this.handleContactSelection(
                                    contact.Id,
                                    contact.Name,
                                    contact.Email,
                                    contact.Phone,
                                    contact.LastFourCCDigits
                                )
                            }}
                        >
                            {contact.Phone}
                            <br className={contact.Email ? '' : 'hidden'} /> {contact.Email}
                            <br className={contact.LastFourCCDigits ? '' : 'hidden'} />
                            <span style={this.props.requireCC && contact.LastFourCCDigits ? {} : { display: 'none' } }>
                                <Icon size={24} icon={
                                    contact.CCType === 'Visa' ? ccVisa
                                    : contact.CCType === 'MasterCard' ? ccMastercard
                                        : contact.CCType === 'AmericanExpress' ? ccAmex
                                            : contact.CCType === 'Discover' ? ccDiscover
                                                : creditCardAlt} /> {contact.CCType} *{contact.LastFourCCDigits}
                            </span>
                            <br className={this.props.requireCC && contact.LastFourCCDigits === '' ? '' : 'hidden'} />
                            <span style={this.props.requireCC && contact.LastFourCCDigits === '' ? {} : { display: 'none' } }>
                                No valid primary credit card.
                            </span>
                        </ListGroupItem>
                    )}
                </ListGroup>

                <ResetOrderPlannerDataButton />

                <Button style={{ marginLeft: '15px' }}
                    onClick={() => {

                        if (localStorage.getItem('orderPlannerContact') !== null) {
                            window.open('/order-planner-delivery', '_self');
                        } else {
                            confirmAlert({
                                title: 'Error',
                                message: 'You must select a contact before proceeding with this order.',
                                buttons: [
                                    {
                                        label: 'OK'
                                    }
                                ]
                            });
                        }
                }}>
                    Next &raquo;
                </Button>
            </div>
        );
    }
}

export default connect(
    state => state.orderPlannerContact,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(OrderPlannerContact);


// WEBPACK FOOTER //
// ./src/components/sales/OrderPlannerContact.js